/**
 * Utilitários puros (sem React) para a origem do telefone no modal de efetivar.
 */

const SERVICE_LINE_PREFIXES = ["0800", "0300", "0500", "0900"];

/**
 * Espelho em JS de normalizeBrazilianPhone
 * (backend/src/services/PolicyStagingService/normalizePhoneNumber.ts) — só
 * para o frontend avisar sem rejeitar o que o backend aceita. O backend
 * continua sendo a fonte de verdade; se as duas leituras algum dia
 * divergirem, é ele quem decide.
 *
 * Descasca "00" e "55" e o zero de discagem nacional ANTES de checar o
 * formato — é o que faz "(048)991861322" (padrão HDI) validar em vez de
 * ser rejeitado só por ter 12 dígitos começando em 0.
 */
export function normalizeBrazilianPhoneFrontend(raw) {
  const rawDigits = String(raw || "").replace(/\D/g, "");
  if (!rawDigits) return null;

  let digits = rawDigits;
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.length > 11 && digits.startsWith("55")) digits = digits.slice(2);

  if (SERVICE_LINE_PREFIXES.some((prefix) => digits.startsWith(prefix))) return null;

  if (digits.length > 10 && digits.startsWith("0")) digits = digits.slice(1);

  if (digits.length !== 10 && digits.length !== 11) return null;

  const ddd = Number(digits.slice(0, 2));
  if (!Number.isFinite(ddd) || ddd < 11 || ddd > 99) return null;
  if (digits.length === 11 && digits[2] !== "9") return null;

  return digits;
}

const str = (v) => (typeof v === "string" ? v.trim() : "");

/** Chave de comparação sem máscara; cai para os dígitos crus se não normalizar. */
const comparisonKey = (raw) =>
  normalizeBrazilianPhoneFrontend(raw) || String(raw || "").replace(/\D/g, "");

/**
 * Valor inicial do campo: celular do cadastro tem prioridade; depois o celular
 * lido do PDF; depois o fixo do PDF; senão vazio.
 */
export function decidePhoneSource({ cadastro, pdfPhone, pdfPhoneFixed } = {}) {
  const fromCadastro = str(cadastro);
  if (fromCadastro) return { value: fromCadastro, source: "cadastro" };
  const fromPdf = str(pdfPhone) || str(pdfPhoneFixed);
  if (fromPdf) return { value: fromPdf, source: "pdf" };
  return { value: "", source: "vazio" };
}

/**
 * Etiqueta do campo: "cadastro" enquanto o valor atual equivale ao do cadastro,
 * "alterado" quando difere, null quando não há valor de cadastro.
 */
export function phoneLabelState(current, cadastroValue) {
  const base = comparisonKey(cadastroValue);
  if (!base) return null;
  return comparisonKey(current) === base ? "cadastro" : "alterado";
}
